import { createFileRoute, Outlet } from '@tanstack/react-router';

/**
 * AI Performance Insights — the layout route for the section.
 *
 * Not flag-gated. The gate existed only because the read API was undeployed, so the
 * page could have rendered nothing but its empty state; that API is live now
 * (`/v1/enrichments/{workflowId}/performance-insights/**`, agentic-workflow-service
 * #661), so access is permission-only like every ungated section.
 */
export const Route = createFileRoute('/_authenticated/_tenant/ai-performance')({
  component: () => <Outlet />,
});
